import React from "react";
import { Link } from "react-router-dom";
import OfferTag from "../../modules/shared/OfferTag";

type DiscoverOfferCardProps = {
    imgSrc: string;
    heading: string;
    icon: string;
    label: string;
    status: string;
    highlight?: boolean;
    linkToMerchant?: string;
    linkToOffer?: string;
    offerType?: string | null | undefined;
    countOfferView?: (arg:any) => void;
    offerId?: string; 
};

const DiscoverOfferCard: React.FC<DiscoverOfferCardProps> = ({
    imgSrc,
    heading,
    icon,
    label,
    status,
    highlight = false,
    linkToMerchant ,
    linkToOffer ,
    offerType,
    countOfferView = () => {},
    offerId
}) => (
    <div 
    className="bg-[#1E1E1E] rounded-[10px] w-full flex flex-col"
    onClick={() => countOfferView({ variables: { offerId } })}>
        <Link to={`${linkToOffer}`}>
            <div className="relative h-[110px]">
                <img
                    className=" w-full h-full rounded-t-[10px] object-cover"
                    src={imgSrc}
                    alt={heading}
                />
                <span className="absolute pl-[10px] top-[13px]">
                    <OfferTag offerType={offerType} />
                </span>
            </div>
        </Link>

        <div className="px-3 flex-1 flex flex-col py-[10px] gap-2 mt-1">
            <Link to={`${linkToOffer}`}>
                <p className="text-white leading-5 cursor-pointer h-10 text-[1rem] two-line-clamp">{heading}</p>
            </Link>
            <Link to={`${linkToMerchant}`} className="flex gap-2 items-center">
                <div className="flex gap-2 items-center w-[175px]">
                    <img src={icon} className="object-cover rounded-full h-[20px] w-[20px]" alt={label} />

                    <p className="text-[11px] text-white truncate">{label}</p>
                </div>
            </Link>
            <hr className="bg-[#77777] mt-1 border w-full border-[#7777]" />
            <p className={`text-[12px] py-1 mt-auto ${highlight ? "text-[#FF6757]" : "text-[#6FC813]"}`}>
                {status}
            </p>
        </div>
    </div>
);

export default DiscoverOfferCard;